import React from "react";
import Background from "./Background";

export default function NotFound() {
  return (
    <main className="not-found-page registerPage">
      <Background />
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <section className="form"></section>
    </main>
  );
}
